import { useQuery } from '@tanstack/react-query';
import { teamsQueryKeys } from '@/utils/queryKeys';
import { listTeamsQuery } from '../api/listTeamsQuery';

export const useAllTeamsList = () => {
  const query = useQuery({
    queryKey: teamsQueryKeys.list(),
    refetchOnWindowFocus: false,
    enabled: true,
    queryFn: async () => {
      const data = await listTeamsQuery({});
      return data;
    },
  });

  return query;
};
